import React from "react";
import { TextField, TextFieldProps } from "@mui/material";
import { useFormContext, Controller, RegisterOptions } from "react-hook-form";

type FormTextFieldProps = TextFieldProps & {
  name: string;
  rules?: RegisterOptions;
  required?: boolean;
  validation?: RegisterOptions;
  customError?: string;
};

export default function FormTextField({
  name,
  rules,
  required,
  validation,
  customError,
  ...rest
}: FormTextFieldProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const fieldError = errors[name];

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? "This field is required" : false,
        ...rules,
        ...validation,
      }}
      render={({ field }) => (
        <TextField
          {...field}
          {...rest}
          error={!!customError || !!fieldError}
          helperText={
            customError
              ? customError
              : fieldError
                ? String(fieldError.message)
                : rest.helperText
          }
        />
      )}
    />
  );
}
